import { render, staticRenderFns } from "./mapLoca.vue?vue&type=template&id=f3b8f936&"
import script from "./mapLoca.vue?vue&type=script&lang=js&"
export * from "./mapLoca.vue?vue&type=script&lang=js&"
import style0 from "./mapLoca.vue?vue&type=style&index=0&id=f3b8f936&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports